import * as NewRelic from '@newrelic/browser-agent';

export const newRelicPlugin = {
  install(Vue, { accountID, applicationID, licenseKey } = {}) {
    const browserAgentOptions = {
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] }
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey,
        applicationID,
        sa: 1
      },
      loader_config: {
        accountID,
        trustKey: `${accountID}`,
        agentID: `${applicationID}`,
        licenseKey,
        applicationID: `${applicationID}`
      }
    };

    Vue.$newRelicBrowserAgent = new NewRelic.BrowserAgent(browserAgentOptions);
  }
};

export default newRelicPlugin;
